export const buildInfo = { buildId: "3a8101abf5c2f063922ef36d64566232ece23658" };
